import React, {useEffect, useState} from 'react';
import styles from "../css/Account.module.css";
import { Chip, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import Button from "components/inputs/Button";

import { useDispatch, useSelector } from "react-redux";
import { accountActions } from "reducers/account";
import { commonActions } from "reducers/common";
import { resetArray } from "service/util/resetArray";
import AccountService from "service/apiConfig/AccountService";

const AccountSearch = () => {
    const dispatch = useDispatch();
    const roles = useSelector(state => state.accountData.roles);
    const [keyword, setKeyword] = useState('');
    const [roleId, setRoleId] = useState('');

    useEffect(() => {
        AccountService.getRoles()
            .then(response => {
                dispatch(accountActions.setRoles(response.data.data));
            })
            .catch(err => console.log(err));
    }, [dispatch])

    const handleChangeRole = (e) => {
        setRoleId(e.target.value);
    }
    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value)
    }
    const handleSearch = () => {
        dispatch(commonActions.trueIsLoading());
        AccountService.getAll(keyword, roleId)
            .then(response => {
                const arr = resetArray(response)
                dispatch(accountActions.setAccountList(arr))
                dispatch(commonActions.falseIsLoading());
            })
            .catch(err => console.log(err));
    }
    const handleReset = () => {
        AccountService.getAll()
            .then(response => {
                const arr = resetArray(response)
                dispatch(accountActions.setAccountList(arr))
                dispatch(commonActions.falseIsLoading());
            })
            .catch(err => console.log(err));
    }
    const handleKeydown = (e) => {
        if (e.key === 'Backspace') {
            handleReset();
        } else if (e.key === 'Enter') {
            handleSearch();
        }
    }
    return (
        <div className={styles.accountSearchWrap}>
            <div>
                <label className={styles.searchLabel}>
                    <Chip label="어드민 권한" />
                </label>
                <FormControl size="small" sx={{ minWidth: "223px" }}>
                    <InputLabel id="demo-simple-select-label">권한</InputLabel>
                    <Select
                        label={"role"}
                        onChange={handleChangeRole}
                        name={"role"}
                        value={roleId || ''}
                    >
                        {roles.map((role, index) => (
                            <MenuItem key={role.id} value={role.id}>{role.name} / {role.category}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div>
                <label className={styles.searchLabel}>
                    <Chip
                        label="키워드"
                        icon={<Search />}
                    />
                </label>
                <TextField onKeyDown={handleKeydown} className={styles.textInput} value={keyword || ''} onChange={handleChangeKeyword} name={"keyword"} size={"small"} variant={"outlined"} />
            </div>
            <div>
                <Button onClick={handleSearch}>검색</Button>
                <Button onClick={handleReset} style={{ marginLeft: '0.2rem' }}>초기화</Button>
            </div>
        </div>
    );
};

export default AccountSearch;